var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.9 5a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m.9 1-.001 6.399.801.001v.4H6.4v-.4l.8-.001V6.4h-.8V6zM16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0"
})));
export default SvgInfo;